export const ELIGIBLE_PEOPLE_LOAD = 'ELIGIBLE_PEOPLE_LOAD'
export const ELIGIBLE_PEOPLE_LOAD_PENDING = 'ELIGIBLE_PEOPLE_LOAD_PENDING'
export const ELIGIBLE_PEOPLE_LOAD_FULFILLED = 'ELIGIBLE_PEOPLE_LOAD_FULFILLED'
export const ELIGIBLE_PEOPLE_LOAD_REJECTED = 'ELIGIBLE_PEOPLE_LOAD_REJECTED'

export const FILTER_ELIGIBLE_PEOPLE_LOAD = 'FILTER_ELIGIBLE_PEOPLE_LOAD'
export const FILTER_ELIGIBLE_PEOPLE_LOAD_PENDING = 'FILTER_ELIGIBLE_PEOPLE_LOAD_PENDING'
export const FILTER_ELIGIBLE_PEOPLE_LOAD_FULFILLED = 'FILTER_ELIGIBLE_PEOPLE_LOAD_FULFILLED'
export const FILTER_ELIGIBLE_PEOPLE_LOAD_REJECTED = 'FILTER_ELIGIBLE_PEOPLE_LOAD_REJECTED'

export const SET_SELECTED_ALL_USERS = 'SET_SELECTED_ALL_USERS'
export const SET_UNSELECTED_ALL_USERS = 'SET_UNSELECTED_ALL_USERS'
export const SELECT_USER = 'SELECT_USER'
export const UNSELECT_USER = 'UNSELECT_USER'
export const SET_SELECTED = 'SET_SELECTED'
export const CLEAR_ELIGIBLE_DATA = 'CLEAR_ELIGIBLE_DATA'
export const SEARCH_UN_SELECTED = 'SEARCH_UN_SELECTED'
export const SEARCH_SELECTED = 'SEARCH_SELECTED'
